import { http } from 'services/BaseApi';
import { logger } from 'services/logging/appInsights';

export const getHomePageDataService = async (userId: string): Promise<any> => {
  try {
    return await http.get(`home/${userId}`);
  } catch (error) {
    logger.error(error, 'getHomePageDataService', 'homeService.ts');
    return error;
  }
};
